<div class="lng-change-wrapper">
  <select (ngModelChange)="setLang($event)"
          [ngModel]="selectedLang">
    <option
      [attr.selected]="lang.active"
      [value]="lang.lang" *ngFor="let lang of langs">{{lang.title}}</option>
  </select>
</div>
